import ServiceGraphQL from 'src/service/gql-service';
import { updateUser } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

export const UpdateUser = (variables) => {
  const params = {
    query: updateUser.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
